import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'
import { ApiError } from '@/util/errors/api-error'

export type AnalyticsApiErrorProps = {
  errorType: string
  statusCode?: number
}

/** Maps caught errors to the errorType/statusCode shape used on analytics failure events. */
export function getAnalyticsApiErrorProps(error: unknown): AnalyticsApiErrorProps {
  if (error instanceof ApiError) {
    return { errorType: 'api_error', statusCode: error.status }
  }
  return { errorType: 'unknown_error' }
}

// Extend window for global track reference
declare global {
  interface Window {
    __trackEventGlobal?: TrackEventFn
  }
}

/**
 * Sets the global trackEvent function reference.
 * This is called on every render of useAnalytics to ensure the global reference
 * always points to the latest function with current context values (user, userAccountData, etc.).
 * This is critical for Redux listeners that use getTrackEventGlobal() to track events
 * with the correct user authentication context.
 */
export function setTrackEventGlobal(fn: TrackEventFn) {
  window.__trackEventGlobal = fn
}

export function getTrackEventGlobal(): TrackEventFn | undefined {
  return window.__trackEventGlobal
}
